
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkCalculationitemDiscountTypeEnum } from '../models/work-calculationitem-discount-type-enum';

export function getCreateDiscountCalculationitemDtoFormGroup() {
return new FormGroup({
    calculationId: new FormControl<number | undefined>(undefined, [Validators.required]),
    discountType: new FormControl<WorkCalculationitemDiscountTypeEnum | undefined>(undefined, [Validators.required]),
    value: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      